const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.enablePerformanceObserver();
    this.appendSellingPlanInputs();
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.listenToFrequencyChange();
    this.setDefaultSelection();
    //this.updatePrice();

      this.debugFormSubmission();
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get addToCartForms() {

    const formsInSection = this.shopifySection?.querySelectorAll('[action*="/cart/add"]') || [];
    const formsInSticky = this.mobileStickyForm?.querySelectorAll('[action*="/cart/add"]') || [];
    
    return [...formsInSection, ...formsInSticky];
    //return this.shopifySection.querySelectorAll('[action*="/cart/add"]');
  }


  get variantIdInput() {
   
    const input =
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[0]?.querySelector(`select[name="id"]`) ||
      this.mobileStickyForm?.querySelector('input[name="id"]') ||
      this.mobileStickyForm?.querySelector('select[name="id"]');
    return input;

  }

  get visibleSellingPlanForm() {
    return (
    this.shopifySection.querySelector(`section[data-variant-id="${this.variantIdInput?.value}"]`) ||
    this.mobileStickyForm?.querySelector(`section[data-variant-id="${this.variantIdInput?.value}"]`) ||
    this.mobileStickyForm // fallback to sticky form container
  );
  }

  get mobileStickyForm() {
  return document.querySelector('.sticky-product-form-container');
}

  get sellingPlanInput() {
        const input =
      this.shopifySection.querySelector('.selected-selling-plan-id') ||
      this.mobileStickyForm?.querySelector('.selected-selling-plan-id');
    return input;
  }

  get sellingPlanInputs() {
        const inputs =
      this.shopifySection.querySelectorAll('.selected-selling-plan-id') ||
      this.mobileStickyForm?.querySelectorAll('.selected-selling-plan-id') ||
      [];
    return inputs;
  }

  get selectedPurchaseOption() {
      const selected = this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
    return selected;
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  /* --- Core Setup --- */
  appendSellingPlanInputs() {
   this.addToCartForms.forEach((form) => {
    if (!form.querySelector('.selected-selling-plan-id')) {
      const clone = this.sellingPlanInput.cloneNode(true);
      form.appendChild(clone); // append inside the form, not outside
    }
  });

    // 🔥 Also add to sticky mobile form if it exists
    if (this.mobileStickyForm && !this.mobileStickyForm.querySelector('.selected-selling-plan-id')) {
        const clone = this.sellingPlanInput.cloneNode(true);
      this.mobileStickyForm.appendChild(clone);
    }

     this.updateSellingPlanInputsValues();

  }

  updateSellingPlanInputsValues() {
    const value = this.sellingPlanInputValue;
    this.sellingPlanInputs.forEach((input) => {
      input.value = value;
    });
      const stickyInput = this.mobileStickyForm?.querySelector('.selected-selling-plan-id');
      if (stickyInput) {
        stickyInput.value = value;
      }
  }

  get sellingPlanInputValue() {
    const option = this.selectedPurchaseOption;
    if (!option) return '';
    return option.dataset.radioType === 'selling_plan'
      ? option.dataset.sellingPlanId
      : '';
  }

  /* --- Variant Switching --- */
  showSellingPlanForm(form) {
    form?.classList.remove(hiddenClass);
  }

  hideSellingPlanForms(forms) {
    forms.forEach((form) => form.classList.add(hiddenClass));
  }

  handleSellingPlanFormVisibility() {
    const formForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`
    );
    const formsForOtherVariants = this.shopifySection.querySelectorAll(
      `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`
    );
    this.showSellingPlanForm(formForSelectedVariant);
    this.hideSellingPlanForms(formsForOtherVariants);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
    this.listenToFrequencyChange();
    this.setDefaultSelection();
  }

  listenToVariantChange() {
    this.listenToAddToCartForms();
    const variantInput =
      this.variantIdInput || this.mobileStickyForm?.querySelector('[name="id"]');

    if (variantInput?.tagName === 'INPUT') {
      const observer = new MutationObserver(() => this.handleVariantChange());
      observer.observe(variantInput, { attributes: true });
    }

    variantInput?.addEventListener('change', () => this.handleVariantChange());
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((form) => {
      form.addEventListener('change', () => this.handleVariantChange());
    });
  }

/* --- Auto-check subscription by default (only if product requires it) --- */
setDefaultSelection() {
 const selectedOption = this.selectedPurchaseOption;
  if (selectedOption) {
    // Already something selected, sync inputs
    this.handleRadioButtonChange(selectedOption);
    return;
  }

  // Only auto-check subscription if explicitly required
  const autoShipRadio = this.visibleSellingPlanForm?.querySelector(
    'input[data-radio-type="selling_plan"]'
  );

  if (autoShipRadio) {
    autoShipRadio.checked = true;
    this.handleRadioButtonChange(autoShipRadio);
  }
}

  /* --- Handle subscription + frequency --- */
  handleRadioButtonChange(selectedOption) {
    this.selectedPurchaseOption = selectedOption;
      this.addToCartForms.forEach(form => {
    const input = form.querySelector('.selected-selling-plan-id');
    if (input) input.value = selectedOption.dataset.sellingPlanId;
  });
    this.updateSellingPlanInputsValues();
    //this.updatePrice();
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm?.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', (event) => {
        this.handleRadioButtonChange(event.target);
      });
    });
  }

  listenToFrequencyChange() {
    const frequencySelect = this.visibleSellingPlanForm?.querySelector(
      '.purchase-option__frequency select'
    );
    if (!frequencySelect) return;

    frequencySelect.addEventListener('change', (event) => {
        const selectedOption = this.visibleSellingPlanForm.querySelector(
         'input[data-radio-type="selling_plan"]'
      );
      if (selectedOption) {
        selectedOption.checked = true;
        selectedOption.dataset.sellingPlanId = event.target.value; // update plan ID
        this.handleRadioButtonChange(selectedOption);
      }
    });
  }

  /* --- Price Update Logic --- */
  get priceElement() {
    return this.shopifySection.querySelector('.price');
  }

  // get regularPriceElement() {
  //   return this.shopifySection.querySelector('.price__regular');
  // }

  get salePriceElement() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get salePriceValue() {
    return this.salePriceElement.querySelector('.price-item--sale');
  }

  get regularPriceValue() {
    return this.salePriceElement.querySelector('.price-item--regular');
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption?.dataset.variantPrice;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption?.dataset.variantCompareAtPrice;
  }

  // updatePrice() {
  //   if (
  //     !this.selectedPurchaseOptionComparedAtPrice ||
  //     this.selectedPurchaseOptionComparedAtPrice === this.selectedPurchaseOptionPrice
  //   ) {
  //     // this.showRegularPrice();
  //     // this.hideSalePrice();
  //     this.priceElement.classList.remove('price--on-sale');
  //   } else {
  //     this.showSalePrice();
  //     this.hideRegularPrice();
  //     this.priceElement.classList.add('price--on-sale');
  //   }
  // }

  
  hideSalePrice() {
    this.salePriceElement.style.display = 'none';
  }

  // hideRegularPrice() {
  //   this.regularPriceElement.style.display = 'none';
  // }

  // showRegularPrice() {
  //   this.regularPriceElement.style.display = 'block';
  //   this.salePriceElement.style.display = 'none';
  // }

  showSalePrice() {
    this.salePriceElement.style.display = 'block';
    this.regularPriceValue.innerHTML = this.selectedPurchaseOptionComparedAtPrice;
    this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice;
  }

  /* --- Performance Observer --- */
  enablePerformanceObserver() {
    const observer = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;
        const url = new URL(entry.name);
        if (url.search.includes('variant') || url.search.includes('variants')) {
          // this.updatePrice();
        }
      });
    });
    observer.observe({ entryTypes: ['resource'] });
  }
}

// Initialize widgets on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.selling_plan_app_container').forEach(container => {
    new SellingPlansWidget(container);
  });
});
